import { Container, Grid, GridItem } from "@/components/Grid/Grid.component";
import { Typography } from "@/components/Typography/Typography.component";
import { ResultsPropsModel } from "./Results.model";

const Results = ({ title, resultDataCollection }: ResultsPropsModel) => {
  return (
    <div className="bg-core-black py-20">
      <Container>
        <Grid hasPadding={false}>
          <GridItem span={{ mobile: 4, tablet: 8, desktop: 12 }}>
            <div className="text-core-white grid gap-52 text-center">
              <Typography.LLABEL1>{title}</Typography.LLABEL1>
              <div className="grid justify-items-center gap-6">
                {resultDataCollection.map((item, index) => (
                  <div
                    key={index}
                    className="grid items-center justify-center gap-2"
                  >
                    <Typography.H1 className="max-md:!text-(size:--font-size-h2)">
                      {item.data}
                    </Typography.H1>
                    <Typography.H7>{item.label}</Typography.H7>
                  </div>
                ))}
              </div>
            </div>
          </GridItem>
        </Grid>
      </Container>
    </div>
  );
};

export default Results;
